<script>
    import {HeroForm} from '../store.js';
    import {getContext} from 'svelte';
    const {url} = getContext('APP');
    let changeClr = 'before';
    let changeClr2 = 'before';
    const formNo = Object.fromEntries(new URLSearchParams($url.search));
    const hearOptions = [
        'Google Search',
        'Google Ads',
        'Youtube',
        'Draper U Alumni (Please Specifiy)',
        'Tech Meetup (Please Specifiy)',
        'Flyer',
        'Facebook',
        'Twitter',
        'LinkedIn',
        'Instagram',
        'Draper U Staff (Please Specify)',
        'DraperTV',
        'Startup U',
        'SoGoal',
        'Events (Please Specify) ',
        'Other (Please Specify)',
    ];
    const visaOptions=[
        'Yes',
        'No',
        'ESTA',
        'U.S. Citizen',
    ];
    const formData = {
        business: '',
        aid: '',
        referalName: '',
        hearAbout: '',
        hearAboutOthers: '',
        visa: '',
    };
    if (HeroForm.get() != undefined) {
        formData.business = HeroForm.get().business;
        formData.aid = HeroForm.get().aid;
        formData.referalName = HeroForm.get().referalName;
        formData.hearAbout = HeroForm.get().hearAbout;
        formData.visa = HeroForm.get().visa;
        formData.hearAboutOthers = HeroForm.get().hearAboutOthers;
}
    $: if (HeroForm.get() != undefined) {
        HeroForm.update((n)=> n={session: HeroForm.get().session, name: HeroForm.get().name, email: HeroForm.get().email,
            country: HeroForm.get().country, countryCode: HeroForm.get().countryCode,
            city: HeroForm.get().city, phoneNumber: HeroForm.get().phoneNumber, dateOfBirth: HeroForm.get().dateOfBirth,
            gender: HeroForm.get().gender,
            technicalSkill: HeroForm.get().technicalSkill, englishAbility: HeroForm.get().englishAbility,
            industry: HeroForm.get().industry, industryOther: HeroForm.get().industryOther,
            business: formData.business, visa: formData.visa,
            aid: formData.aid, referalName: formData.referalName,
            hearAbout: formData.hearAbout, hearAboutOthers: formData.hearAboutOthers,
            startup: '',
            aboutYourSelf: HeroForm.get().aboutYourSelf,
            portfolioURL: HeroForm.get().portfolioURL, buildingPlan: HeroForm.get().buildingPlan,
            travelBudget: HeroForm.get().travelBudget, buildingWeeks: HeroForm.get().buildingWeeks,
            invitedtoProgram: HeroForm.get().invitedtoProgram, ackowledged: HeroForm.get().ackowledged,
        });
    }
    /**
     *
     * @param {string}object
     */
    async function SaveData() {
        if (formNo.name === 'HeroTraining') {
            location.href='/apply?name=HeroTraining&FormNo=submitform';
        } else if (formNo.name === 'KanooInnovationHub') {
            location.href='/apply?name=KanooInnovationHub&FormNo=submitform';
        }
    }
    /**
     *
     *
     */
    function goBack() {
        if (formNo.name === 'HeroTraining') {
            location.href='/apply?name=HeroTraining&FormNo=thirdform';
        } else if (formNo.name === 'KanooInnovationHub') {
            location.href='/apply?name=KanooInnovationHub&FormNo=thirdform';
        }
    }
    $: if (formData.visa != '') {
        changeClr = 'chclr';
    } else {
        changeClr = 'before';
    }
    $: if (formData.hearAbout != '') {
        changeClr2 = 'chclr';
    }
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(),
        'event': 'gtm.js'});
        const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<div class="desktop">
    <div class="back-div">
        <div>
            <div class="process">
                <p>Process</p>
            </div>
            <div class="process_x">
                <p>
                    Our Application is a 4 step process, where you provied the
                    requierd information. This form costs $5 for submission.
                </p>
            </div>
        </div>
        <ul style="list-style: none;">
            {#each Array(4) as _, i}
                <li class="vl" />
            {/each}
        </ul>
        <div class="front-div">
            <div>
                <div class="back-arrow" on:click={() => ( goBack())}>
                    <img src="images/apply/back_arrow.svg" alt="">
                </div>
                <form on:submit|preventDefault={SaveData}>
                    <div>
                            <div style="margin-left: 4.96vw;" class="text">
                                <label for="idea"
                                    >Pitch us your business Or tell us why you
                                    were put on this Earth</label
                                >

                                <div style="margin-top: 0.529vw;margin-top: 0.397vw;">
                                    <textarea
                                        required
                                        class="textarea"
                                        rows="5"
                                        placeholder="Max count 250 words"
                                        bind:value={formData.business}
                                    />
                                </div>
                            </div>
                        <div style="display:flex;">
                            <div style="margin-left: 4.96vw;" class="text">
                                <label for="Visa">Do you have tourist Visa?</label>
                                <div>
                                    <select
                                        class = "clr {changeClr}"  
                                        bind:value={formData.visa}
                                        required
                                    >
                                    <option style="color: rgba(171, 171, 171, 1);" value="" disabled selected>Please Select</option>
                                        {#each visaOptions as option}
                                            <option value={option}>
                                                {option}
                                            </option>
                                        {/each}                
                                    </select>
                                </div>
                            </div>
                            <div style="margin-left: 5.96vw;" class="text">
                                <label for="aid">
                                    Partial Financial Aid <span class="span"
                                        >( Applies to Hero Training Only )</span
                                    >
                                </label>
                                <div style="margin-top: 0.529vw;">
                                    <input class="checkbox" type="checkbox" bind:checked={formData.aid}/>
                                    <div style="    margin-top: -3.7vw;
                                    margin-left: 1.23vw;">
                                        <label for="f_aid" style="color: #B6B6B6;font-weight: 500;
                                        padding-left: 1vw;">Yes</label>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div style="display:flex;">
                            <div style="margin-left: 4.96vw;">
                                <label for="refrel">
                                    Referal Name or Code <span class="span"
                                        >( Optional )</span
                                    >
                                </label>

                                <div style="margin-top: 0.397vw;">
                                    <input
                                        type="text"
                                        id="email"
                                        placeholder="ex, “Joe”"
                                        style="width:18.915vw ;"
                                        bind:value={formData.referalName}
                                    />
                                </div>
                            </div>

                            <div style="margin-left: 2.381vw;">
                                <label for="aboutus">How did you hear about Draper U?</label>

                                <div>
                                    <select
                                        class = "clr {changeClr2}"
                                        bind:value={formData.hearAbout}
                                        required
                                    >
                                    <option style="color: rgba(171, 171, 171, 1);" value="" disabled selected>Please Select</option>
                                        {#each hearOptions as option}
                                            <option value={option}>
                                                {option}
                                            </option>
                                        {/each}  
                                    </select>
                                </div>
                            </div>

                            <div style="margin-left: 2.381vw;">
                                <label for="city"
                                    >If you listed others? Please mention below</label
                                >

                                <div style="margin-top: 0.397vw;">
                                    <input
                                        type="text"
                                        id="email"
                                        placeholder="Please Select"
                                        style="width:18.915vw ;"
                                        bind:value={formData.hearAboutOthers}
                                    />
                                </div>
                            </div>
                        </div>
                        <div style="margin-left: 5vw; margin-top: 5vw;">
                            <button
                                style=" background-color: rgba(60, 116, 192, 1);
                                border-radius: 1.984vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 1.190vw;"
                                >Next</button
                            >
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="mobile">
    <div class="back-div-mobile">
        <div>
            <div class="process-mobile">
                <p>Process</p>
            </div>
            <div class="process_x-mobile">
                <p>
                    Our Application is a 4 step process, where you provied the
                    requierd information. This form costs $5 for submission.
                </p>
            </div>
        </div>

        <div style="margin-top: -6vw;">
            <ul
                style="list-style: none; display: flex; justify-content: space-around; margin-left: -2vw; width: 100vw;"
            >
                {#each Array(4) as _, i}
                    <li class="vl-mobile" />
                {/each}
            </ul>
        </div>

        <div class="front-div-mobile">
            <form on:submit|preventDefault={SaveData}>
                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">
                        Pitch us your business Or tell us why you<br />were put
                        on this Earth
                    </p>

                    <div style="margin-top: 0.529vw;">
                        <textarea
                            required
                            class="textarea-mobile"
                            rows="5"
                            placeholder="Max count 250 words"
                            bind:value={formData.business}
                        />
                    </div>
                </div>
                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">
                        Do you have tourist Visa?
                    </p>
                    <div style="margin-top: 0.529vw;">
                        <select
                            class = "select-mobile {changeClr}"  
                            bind:value={formData.visa}
                            required
                        >
                            <option style="color: rgba(171, 171, 171, 1);" value="" disabled selected>Please Select</option>
                            {#each visaOptions as option}
                                <option value={option}>
                                    {option}
                                </option>
                            {/each} 
                        </select>
                    </div>
                </div>
                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">
                        Partial Financial Aid <span class="span-mobile"
                            >( Applies to Hero Training Only )</span
                        >
                    </p>
                    <div style="margin-top: 0.529vw;">
                        <input class="checkbox-mobile" type="checkbox" bind:checked={formData.aid}/>
                        <p
                            style="font-size: 3.056vw; color: rgb(182, 182, 182); margin-left: 5vw;margin-top: -5vw;"
                        >
                            Yes
                        </p>
                    </div>
                </div>

                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">
                        Referal Name or Code <span class="span-mobile"
                            >( Optional )</span
                        >
                    </p>

                    <div>
                        <input
                            class="input-mobile"
                            style="width: 50.0vw;"
                            type="text"
                            id="email"
                            placeholder="ex, “Joe”"
                            bind:value={formData.referalName}
                        />
                    </div>
                </div>

                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">How did you hear about Draper U?</p>

                    <div style="margin-top: 0.529vw;">
                        <select
                            class = "select-mobile {changeClr2}"
                            bind:value={formData.hearAbout}
                            required
                        >
                            <option style="color: rgba(171, 171, 171, 1);" value="" disabled selected>Please Select</option>
                            {#each hearOptions as option}
                                <option value={option}>
                                    {option}
                                </option>
                            {/each}  
                        </select>
                    </div>
                </div>

                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">
                        If you listed others? Please mention below
                    </p>
                    <div>
                        <input
                            class="input-mobile"
                            style="width: 50.0vw;"
                            type="text"
                            id="email"
                            placeholder="Please Select"
                            bind:value={formData.hearAboutOthers}
                        />
                    </div>
                </div>
                <div style="margin-left: 8vw; margin-top: 5vw; display: flex; gap: 4.673vw;">
                    <button
                            style=" background-color: rgba(60, 116, 192, 1);
                            border-radius: 6.069vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 3.889vw;"
                    >Next</button>
                    <div class="back-arrow-mob" on:click={() => ( goBack())}>
                        <img src="images/apply/back_button.svg" alt="">
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<style>
    option{
        color: black;
    }
    .clr{
        width: 18.915vw; 
        margin-top: 0.397vw;
    }
    .before{
        color: rgba(171, 171, 171, 1);
    }
    .chclr{
        color: black;
    }
    .back-arrow{
        width: 1.72vw;
        height: 0.926vw;
        margin-left: 2.646vw;
        margin-bottom: -1vw;
        margin-top: 1.323vw;
        cursor: pointer;
    }
    .back-arrow img{
        width: 100%;
        height: 100%;
    }
    .back-div {
        position: relative;
        height: 44.812vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        border-top-left-radius: 2vw;
        display: flex;
        margin-bottom: -1.1vw;
        margin-top: 1.1vw;
    
    }
    .front-div {
        position: absolute;
        width: 100%;
        height: 38.294vw;
        background: #ffffff;
        border-bottom-left-radius: 2vw;
        border-bottom-right-radius: 2vw;
        left: 22.25vw;
        bottom: 6.8vw;
    }

    .process {
        font-size: 1.984vw;
        color: rgb(255 255 255);
        font-weight: 400;
        margin-left: 3vw;
        margin-top: 3vw;
    }
    .process_x {
        width: 15.013vw;
        font-size: 0.926vw;
        color: rgb(255 255 255);
        font-weight: 300;
        margin-left: 4.497vw;
    }
    .vl {
        margin-top: 1.984vw;
        border-radius: 0.5vw;
        width: 0.463vw;
        border-left: 0.5vw solid rgba(60, 116, 192, 1);
        height: 5.82vw;
        opacity: 0.3;
        margin-left: 0vw;
    }
    .vl:nth-child(4) {
        border-left: 0.5vw solid white;
        opacity: 100;
    }
    .text {
        color: rgba(0, 32, 75, 1);
        font-weight: 700;
    }
    .checkbox {
        width: 1.389vw;
        height: 1.323vw;
        border-radius: 0.198vw;
        border: 2px solid rgba(60, 136, 195, 1);
        opacity: 40;
        background-color: #3c88c3;
    }
    .textarea {
        width: 40.476vw;
        top: 30.82vw;
        border: 0.132vw solid rgba(171, 171, 171, 1);
        border-radius: 0.661vw;
        padding-left: 2.381vw;
        padding-top: 0.595vw;
        font-size: 0.926vw;
    }
    .textarea::placeholder {
        font-size: 0.926vw;
    }
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url("images/dropdown.svg");
        background-repeat: no-repeat;
        background-position-x: 17vw;
        background-position-y: 1vw;
        background-size: 0.6vw;
    }
    input {
        border: 0.132vw solid rgba(171, 171, 171, 1);
        border-radius: 0.661vw;
        padding-left: 1vw;
        height: 2.7vw;
        font-size: 0.926vw;
    }
    input::placeholder {
        font-size: 0.926vw;
    }
    label {
        font-size: 1.058vw;
        margin-top: 1.984vw;
        color: rgba(0, 32, 75, 1);
        font-weight: 700;
    }
    select {
        border: 0.132vw solid rgba(171, 171, 171, 1);
        border-radius: 0.661vw;
        padding-left: 1vw;
        height: 2.7vw;
        background-color: transparent;
        font-size: 0.926vw;
    }
    .span {
        font-size: 1.058vw;
        margin-top: 1.984vw;
        color: #003d8f;
        font-weight: 300;
    }
    .back-div-mobile {
        position: relative;
        height: 225vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        border-top-left-radius: 8vw;
        border-top-right-radius: 8vw;
        margin-bottom: -0.5vw;
    }

    .process-mobile {
        font-size: 5.556vw;
        color: rgb(255 255 255);
        font-weight: 400;
        margin-left: 7.222vw;
        padding-top: 9.167vw;
    }
    .process_x-mobile {
        width: 73.889vw;
        font-size: 3.187vw;
        color: rgb(255 255 255);
        margin-left: 7.222vw;
    }
    .front-div-mobile {
        position: absolute;
        width: 92.778vw;
        padding-bottom: 5vw;
        top: 45vw;
        background: #ffffff;
        border-top-left-radius: 4.5vw;
        border-bottom-left-radius: 4.5vw;
        left: 7.222vw;
    }
    .vl-mobile {
        border-radius: 0.5vw;
        border-left: 1.3vw solid rgba(60, 116, 192, 1);
        height: 15.460999999999999vw;
        opacity: 0.3;
        margin-left: 0vw;
        transform: rotate(90deg);
    }
    .vl-mobile:nth-child(4) {
        border-left: 1.3vw solid white;
        opacity: 100;
    }
    .p-mobile {
        font-size: 3.187vw;
        margin-top: 6.667vw;
        color: rgba(0, 32, 75, 1);
        font-weight: 700;
    }
    .span-mobile {
        font-size: 3.187vw;
        margin-top: 6.667vw;
        color: #003d8f;
        font-weight: 300;
    }
    .textarea-mobile {
        width: 78.333vw;
        height: 45.278vw;
        border: 0.556vw solid rgba(171, 171, 171, 1);
        border-radius: 2.778vw;
        padding-left: 5.5vw;
        padding-top: 0.595vw;
    }
    .select-mobile {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url(images/dropdown.svg);
        background-repeat: no-repeat;
        background-position-x: 43.3vw;
        background-position-y: 3vw;
        background-size: 3.7vw;
    }
    .select-mobile {
        border: 0.556vw solid rgba(171, 171, 171, 1);
        border-radius: 1.661vw;
        padding-left: 5.5vw;
        height: 9.111vw;
        background-color: transparent;
        width: 50.0vw;
    }
    .checkbox-mobile {
        width: 3.731vw;
        height: 3.553vw;
        border-radius: 6.198vw;
        border: 5vw solid rgba(60, 136, 195, 1);
        opacity: 40;
    }
    .input-mobile {
        border: 0.556vw solid rgba(171, 171, 171, 1);
        border-radius: 1.661vw;
        padding-left: 5.5vw;
        height: 9.111vw;
    }
    .desktop {
        display: block;
        width: 100%;
        overflow: hidden;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .back-arrow-mob{
            width: 10.047vw;
            height: 7.243vw;
        }
        .back-arrow-mob img{
            width: 100%;
            height: 100%;
        }
        .textarea,.textarea::placeholder,
        input, input::placeholder,label,
        select, .span{
            font-size: 3.187vw;
        }
    }
</style>
